import { render, staticRenderFns } from "./opentuan.vue?vue&type=template&id=6da146a5&"
import script from "./opentuan.vue?vue&type=script&lang=js&"
export * from "./opentuan.vue?vue&type=script&lang=js&"
import style0 from "./opentuan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports